// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 992px) {\n  .modal_user_certifications-component .modal-lg {\n    max-width: 1100px; } }\n", ""]);
// Exports
module.exports = exports;
